import { render, staticRenderFns } from "./SimplePrice.vue?vue&type=template&id=753b2db3"
import script from "./SimplePrice.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimplePrice.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SimplePrice.vue?vue&type=style&index=0&id=753b2db3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports